module.exports = __webpack_public_path__ + "img/indicator_lamp.20534b99.svg";